/**
 * Cómo se NOMBRA cada permiso en la interfaz.
 *
 * La lista de permisos NO vive aquí: se pide a `GET /api/auth/permissions/catalog`,
 * cuya fuente de verdad es `backend/src/constants/permissions.js`. Esto es solo la
 * traducción. Un permiso nuevo aparece igualmente en el editor, con su id crudo como
 * etiqueta, así que olvidar añadirlo aquí no lo esconde.
 */

export const PERMISSION_LABELS = {
  'users.view': 'Ver usuarios',
  'users.manage': 'Crear y editar usuarios',
  'users.change-role': 'Cambiar el rol de un usuario',
  'users.reset-password': 'Resetear contraseñas',
  'users.grant-admin': 'Crear o promover administradores',
  'users.reset-admin-password': 'Resetear la contraseña de un administrador',
  'permissions.manage': 'Editar permisos por usuario',

  'camps.manage': 'Gestionar campamentos',
  'clubs.manage': 'Gestionar clubes',
  'directors.manage': 'Gestionar directores',
  'events.manage': 'Gestionar eventos',
  'rubrics.manage': 'Gestionar rúbricas',
  'grades.publish': 'Publicar calificaciones',
  'grades.manage': 'Recalcular y corregir calificaciones',
  'affiliations.manage': 'Gestionar afiliaciones y zonas',

  'clubs.view': 'Ver clubes',
  'directors.view': 'Ver directores',
  'reports.view': 'Ver reportes',
  'reports.view-all-zones': 'Ver reportes de todas las zonas',

  'grades.edit-graded': 'Modificar una calificación ya guardada',

  'watchtower.view': 'Ver Watchtower (observabilidad)',
};

/** Nombre de cada familia. La familia es el prefijo del permiso, antes del punto. */
export const PERMISSION_GROUP_LABELS = {
  users: 'Usuarios',
  permissions: 'Permisos',
  camps: 'Campamentos',
  clubs: 'Clubes',
  directors: 'Directores',
  events: 'Eventos',
  rubrics: 'Rúbricas',
  grades: 'Calificaciones',
  affiliations: 'Afiliaciones',
  reports: 'Reportes',
  watchtower: 'Observabilidad',
};

export const permissionLabel = permission => PERMISSION_LABELS[permission] || permission;

export const permissionGroup = permission => String(permission).split('.')[0];

export const permissionGroupLabel = permission => {
  const group = permissionGroup(permission);
  return PERMISSION_GROUP_LABELS[group] || group;
};

/**
 * Agrupa el catálogo del servidor por familia, conservando su orden: el backend ya
 * lo emite ordenado por dominio y reordenarlo aquí solo despistaría.
 */
export const groupPermissions = (permissions = []) => {
  const groups = new Map();
  for (const permission of permissions) {
    const key = permissionGroup(permission);
    if (!groups.has(key)) groups.set(key, { key, label: permissionGroupLabel(permission), items: [] });
    groups.get(key).items.push(permission);
  }
  return [...groups.values()];
};
